import moment from 'moment'

const momentLocaleByCountry = {
  bra: 'pt-br',
  usa: 'en',
  pry: 'es',
  esp: 'es'
}

const momentLocaleByLanguage = {
  'es-es': 'es',
  'fr-fr': 'fr',
  'en-us': 'en',
  'pt-br': 'pt-br',
  'pt-pt': 'pt'
}

export function getLocale() {
  const country = (localStorage.getItem('country-code') || 'bra').toLowerCase()
  return momentLocaleByCountry[country] || 'pt-br'
}

export function getAppLocale() {
  const language = localStorage.getItem('i18n_redirected')
  return momentLocaleByLanguage[language] || getLocale()
}

export function formatDate(date, type = 'date') {
  if (date === null || date === undefined || date === '') return ''

  const locale = getAppLocale()
  const m = moment(date).locale(locale)

  switch (type) {
    case 'fromNow': // tempo relativo
      return m.fromNow()

    case 'time': // hora localizada
      return m.format('LT')

    case 'dateTime': // data+hora localizada
      return m.format('L LT')

    case 'dateTimeWithSeconds': // data+hora localizada, com segundos
      return m.format('L LTS')

    case 'birthdate': {
      // idade atual
      const years = moment().diff(m, 'years')
      const months = moment().diff(m, 'months')
      const days = moment().diff(m, 'days')

      if (months < 1) {
        return days + 'd'
      }
      if (years < 1) {
        return months + 'm'
      }
      return years + 'y'
    }

    case 'dayAndMonth': // dia e mês
      return m.format('DD MMM')

    case 'abbreviatedMonthAndYear': // mês e ano abreviados
      return m.format('MMM YY')

    case 'weekDay': // dia da semana
      return m.format('ddd')

    case 'weekDayFull': // dia da semana completo
      return m.format('dddd')

    case 'day': // somente o dia do mês
      return m.format('DD')

    case 'month': // somente o mês
      return m.format('MMMM')

    case 'year': // somente o ano
      return m.format('YYYY')

    case 'fullAge': {
      const now = moment()
      const yearsFull = now.diff(m, 'years')
      m.add(yearsFull, 'years')
      const monthsFull = now.diff(m, 'months')
      m.add(monthsFull, 'months')
      const daysFull = now.diff(m, 'days')

      let ageString = ''
      if (yearsFull > 0) {
        ageString += yearsFull + 'y '
      }
      if (monthsFull > 0) {
        ageString += monthsFull + 'm '
      }
      if (daysFull > 0) {
        ageString += daysFull + 'd'
      }
      return ageString.trim()
    }

    case 'greaterThan0Days': {
      const diffDays = Math.abs(moment().diff(m, 'days'))
      return diffDays > 1
    }

    case 'date': // data localizada
    default:
      return m.format('L')
  }
}
